import {useOverrideSubmissionMutation} from "@/api/submissionApi";
import AISparkIcon from "@/assets/colorable/ai_spark.svg?react";
import Button from "@/components/Common/Button";
import Modal from "@/components/Common/Modal";
import {overrideSubmissionModalAtom, reviewContentModalAtom} from "@/store/jotaiAtoms";
import {useAtom, useSetAtom} from "jotai";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const OverrideSubmissionModal: FC = () => {
  const {t} = useTranslation(["content_approval", "common"]);
  const [submissionId, setSubmissionId] = useAtom(overrideSubmissionModalAtom);
  const setReviewContentModal = useSetAtom(reviewContentModalAtom);
  const {mutate: overrideSubmission, isPending} = useOverrideSubmissionMutation(submissionId!);

  const onClose = () => setSubmissionId(null);
  const onSuccess = () => {
    onClose();
    setReviewContentModal(state => {
      state.isOpen = false;
    });
  };

  return (
    <Modal
      backgroundClassName="max-w-md"
      customBottomRow={
        <div className="border-neutral-white-dark flex justify-end gap-3 border-t px-5 py-4">
          <Button buttonStyle="White" className="px-5 py-2.5" onClick={onClose}>
            {t("common:cancel")}
          </Button>
          <Button
            buttonStyle="Gradient"
            className="px-5 py-2.5"
            isLoading={isPending}
            onClick={() => overrideSubmission(undefined, {onSuccess})}>
            {t("approve")}
          </Button>
        </div>
      }
      isLoading={isPending}
      modalTitle={t("approve")}
      onClose={onClose}>
      <div className="border-danger-rubicund bg-danger-light-red flex gap-3 rounded-lg border p-4">
        <AISparkIcon className="text-danger-dark-red mt-0.5 size-4 shrink-0" />
        <div>
          <p className="text-danger-dark-red text-sm font-semibold">{t("admin_override_warning_title")}</p>
          <p className="text-danger-dark-red/80 mt-1 text-sm leading-relaxed">{t("admin_override_warning")}</p>
        </div>
      </div>
    </Modal>
  );
};

export default OverrideSubmissionModal;
